import { observer } from 'mobx-react-lite';
import { AppRoutes } from '~/app/app.routes';
import { AuthService } from '~/service/service.auth';
import { useService } from '~/shared/service/service.base';
import { EmailLink } from '../grid/grid.columns';
import { Col } from '../view.box';
import { LinkView } from '../view.link';
import { FeedbackDrawerItem, FeedbackDrawerTitle, FeedbackDrawerValue } from './feedback.drawer';
import { useFeedbackDrawerContext } from './feedback.drawer.ctx';

export const FeedbackDrawerAuthor = observer(() => {
	const { selectedItem } = useFeedbackDrawerContext();
	const [auth] = useService(AuthService);

	return (
		<Col gap={1}>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Created at:</FeedbackDrawerTitle>
				<FeedbackDrawerValue>{new Date(selectedItem?.createdAt ?? 0).toLocaleString()}</FeedbackDrawerValue>
			</FeedbackDrawerItem>
			<FeedbackDrawerItem>
				<FeedbackDrawerTitle>Created by:</FeedbackDrawerTitle>
				<FeedbackDrawerValue>
					<LinkView to={AppRoutes.UserEdit.buildPath({ id: selectedItem?.createdBy ?? 0 })} target="_blank">
						{selectedItem?.createdByName}
					</LinkView>
				</FeedbackDrawerValue>
			</FeedbackDrawerItem>
			{auth.can('user', 'EMAIL') && (
				<FeedbackDrawerItem>
					<FeedbackDrawerTitle>Created by email:</FeedbackDrawerTitle>
					<FeedbackDrawerValue>
						<EmailLink href={`mailto:${selectedItem?.createdByEmail}`} target="_blank">
							{selectedItem?.createdByEmail}
						</EmailLink>
					</FeedbackDrawerValue>
				</FeedbackDrawerItem>
			)}
		</Col>
	);
});
